import { render, staticRenderFns } from "./BasicMedia.vue?vue&type=template&id=4eea5fde"
import script from "./BasicMedia.vue?vue&type=script&lang=js"
export * from "./BasicMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports